function Switzerland({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2256)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M24.3478 13.2176H18.7827V7.65234H13.2174V13.2176H7.65222V18.7828H13.2174V24.348H18.7827V18.7828H24.3478V13.2176Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Switzerland;
